import React from 'react';
import { MapPin, Navigation } from 'lucide-react';
export function LiveMap() {
  return <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6" data-id="element-225">
      <div className="flex items-center justify-between mb-4" data-id="element-226">
        <h2 className="text-lg font-semibold text-gray-900" data-id="element-227">
          Flotte en temps réel
        </h2>
        <div className="flex items-center space-x-2" data-id="element-228">
          <div className="flex items-center space-x-1" data-id="element-229">
            <div className="w-2 h-2 bg-green-500 rounded-full" data-id="element-230"></div>
            <span className="text-xs text-gray-600" data-id="element-231">67 actifs</span>
          </div>
          <div className="flex items-center space-x-1" data-id="element-232">
            <div className="w-2 h-2 bg-gray-300 rounded-full" data-id="element-233"></div>
            <span className="text-xs text-gray-600" data-id="element-234">13 inactifs</span>
          </div>
        </div>
      </div>
      {/* Map Placeholder */}
      <div className="relative w-full h-64 bg-gray-100 rounded-lg overflow-hidden" data-id="element-235">
        <div className="absolute inset-0 bg-gradient-to-br from-blue-50 to-gray-100" data-id="element-236">
          {/* Simulated Map Markers */}
          <div className="absolute top-1/4 left-1/3 animate-pulse" data-id="element-237">
            <Navigation className="w-4 h-4 text-green-600" data-id="element-238" />
          </div>
          <div className="absolute top-1/2 right-1/3 animate-pulse delay-75" data-id="element-239">
            <Navigation className="w-4 h-4 text-green-600" data-id="element-240" />
          </div>
          <div className="absolute bottom-1/3 left-1/2 animate-pulse delay-150" data-id="element-241">
            <Navigation className="w-4 h-4 text-green-600" data-id="element-242" />
          </div>
          <div className="absolute top-1/3 right-1/4" data-id="element-243">
            <MapPin className="w-4 h-4 text-blue-600" data-id="element-244" />
          </div>
          <div className="absolute bottom-1/4 left-1/4" data-id="element-245">
            <MapPin className="w-4 h-4 text-blue-600" data-id="element-246" />
          </div>
        </div>
        {/* Map Controls */}
        <div className="absolute bottom-4 right-4 flex flex-col space-y-2" data-id="element-247">
          <button className="w-8 h-8 bg-white rounded shadow-sm flex items-center justify-center text-gray-600 hover:bg-gray-50" data-id="element-248">
            +
          </button>
          <button className="w-8 h-8 bg-white rounded shadow-sm flex items-center justify-center text-gray-600 hover:bg-gray-50" data-id="element-249">
            −
          </button>
        </div>
      </div>
      {/* Legend */}
      <div className="mt-4 flex items-center justify-between text-xs" data-id="element-250">
        <div className="flex items-center space-x-4" data-id="element-251">
          <div className="flex items-center space-x-1" data-id="element-252">
            <Navigation className="w-3 h-3 text-green-600" data-id="element-253" />
            <span className="text-gray-600" data-id="element-254">En route</span>
          </div>
          <div className="flex items-center space-x-1" data-id="element-255">
            <MapPin className="w-3 h-3 text-blue-600" data-id="element-256" />
            <span className="text-gray-600" data-id="element-257">Sites</span>
          </div>
        </div>
        <button className="text-blue-600 hover:text-blue-700 font-medium" data-id="element-258">
          Vue complète →
        </button>
      </div>
    </div>;
}